import { render, staticRenderFns } from "./TrustIconsEditor.vue?vue&type=template&id=3bcdb1c2"
import script from "./TrustIconsEditor.vue?vue&type=script&lang=js"
export * from "./TrustIconsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports